import { SalonReport } from "../../../types/reports";

/**
 * The line under a shared copy's title, for the person it was shared with:
 * "Shared by Alice Anderson", plus "· Synced with their changes" while the
 * sharer keeps it in sync (their saved view then replaces this one's).
 * Null for the caller's own reports, including copies whose original was
 * removed (they no longer sync).
 */
export function sharedNoteFor(report: SalonReport): string | null {
  if (!report.shared_by) return null;
  const by = report.shared_by.name
    ? `Shared by ${report.shared_by.name}`
    : "Shared with you";
  const synced = report.sync_with_source && !!report.shared_from_report_id;
  return synced ? `${by} · Synced with their changes` : by;
}
